var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisitorFuture(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z",
    fill: "#F5F6F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6935 18.4855C16.4105 20.8042 16.4105 24.5362 16.4105 32C16.4105 39.464 16.4105 43.1959 18.6935 45.5147C20.9766 47.8334 24.6511 47.8334 32.0002 47.8334C39.3493 47.8334 43.0238 47.8334 45.3069 45.5147C47.5899 43.1959 47.5899 39.464 47.5899 32C47.5899 24.5362 47.5899 20.8042 45.3069 18.4855C43.0238 16.1667 39.3493 16.1667 32.0002 16.1667C24.6511 16.1667 20.9766 16.1667 18.6935 18.4855ZM32.0002 40.3334C33.8128 40.3334 35.2822 38.841 35.2822 37C35.2822 35.1592 33.8128 33.6667 32.0002 33.6667C30.1877 33.6667 28.7181 35.1592 28.7181 37C28.7181 38.841 30.1877 40.3334 32.0002 40.3334Z",
    fill: "#2C8C53"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4617 33.6667L40.2053 27M35.2822 37.0001C35.2822 38.8409 33.8127 40.3334 32.0002 40.3334C30.1875 40.3334 28.7181 38.8409 28.7181 37.0001C28.7181 35.1591 30.1875 33.6667 32.0002 33.6667C33.8127 33.6667 35.2822 35.1591 35.2822 37.0001Z",
    stroke: "#172B4D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1538 32C22.1538 26.4771 26.5621 22 32 22C33.7935 22 35.4749 22.487 36.9231 23.3378",
    stroke: "#172B4D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4104 32.0001C16.4104 24.5362 16.4104 20.8042 18.6934 18.4855C20.9765 16.1667 24.651 16.1667 32.0002 16.1667C39.3492 16.1667 43.0238 16.1667 45.3068 18.4855C47.5899 20.8042 47.5899 24.5362 47.5899 32.0001C47.5899 39.464 47.5899 43.196 45.3068 45.5147C43.0238 47.8335 39.3492 47.8335 32.0002 47.8335C24.651 47.8335 20.9765 47.8335 18.6934 45.5147C16.4104 43.196 16.4104 39.464 16.4104 32.0001Z",
    stroke: "#172B4D",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitorFuture);
export default __webpack_public_path__ + "static/media/visitor-future.21324277550738ff040ebd51013eb8ae.svg";
export { ForwardRef as ReactComponent };